import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import { SelectOption } from './memoriesHelper';
import { map } from 'lodash';

export enum Comparator {
  equal = '=',
  notEqual = '!=',
  greaterThan = '>',
  lessThan = '<',
  greaterThanOrEqual = '>=',
  lessThanOrEqual = '<=',
  oneOf = 'oneOf',
  notOneOf = 'notOneOf',
  containsOneOf = 'containsOneOf',
  notContainsOneOf = 'notContainsOneOf',
  before = 'before',
  after = 'after',
  on = 'on',
  beforeAbsolute = 'beforeAbsolute',
  afterAbsolute = 'afterAbsolute',
  onAbsolute = 'onAbsolute',
  exists = 'exists',
  doesNotExist = 'doesNotExist',
}

const ComparatorLabel: Record<Comparator, string> = {
  [Comparator.equal]: 'equal to',
  [Comparator.notEqual]: 'not equal to',
  [Comparator.greaterThan]: 'greater than',
  [Comparator.lessThan]: 'less than',
  [Comparator.greaterThanOrEqual]: 'greater than or equal',
  [Comparator.lessThanOrEqual]: 'less than or equal',
  [Comparator.oneOf]: 'equals one of',
  [Comparator.notOneOf]: 'does not equal one of',
  [Comparator.containsOneOf]: 'contains one of',
  [Comparator.notContainsOneOf]: 'does not contains one Of',
  [Comparator.before]: 'before',
  [Comparator.after]: 'after',
  [Comparator.on]: 'on',
  [Comparator.beforeAbsolute]: 'before exact date',
  [Comparator.afterAbsolute]: 'after exact date',
  [Comparator.onAbsolute]: 'on exact date',
  [Comparator.exists]: 'exists',
  [Comparator.doesNotExist]: 'does not exist',
};

const notTimestamp = [Comparator.equal, Comparator.notEqual, Comparator.oneOf, Comparator.notOneOf];

const getComparator = (lastSpec: TypeSpec, isExtActionMem: boolean): SelectOption[] => {
  const comparatorMap = {
    timestamp: [
      Comparator.before,
      Comparator.after,
      Comparator.on,
      Comparator.beforeAbsolute,
      Comparator.afterAbsolute,
      Comparator.onAbsolute,
    ],
    string: [...notTimestamp, Comparator.containsOneOf, Comparator.notContainsOneOf],
    object: [...notTimestamp, Comparator.containsOneOf, Comparator.notContainsOneOf],
    number: isExtActionMem
      ? [
          ...notTimestamp,
          Comparator.lessThan,
          Comparator.greaterThan,
          Comparator.lessThanOrEqual,
          Comparator.greaterThanOrEqual,
        ]
      : [...notTimestamp, Comparator.lessThan, Comparator.greaterThan],
    currency: [...notTimestamp, Comparator.lessThan, Comparator.greaterThan],
  };

  const comparators = comparatorMap[lastSpec?.type] || notTimestamp;

  comparators.push(Comparator.exists);
  comparators.push(Comparator.doesNotExist);

  const uniqueComparators = Array.from(new Set(comparators)) as Comparator[];

  return map(uniqueComparators, comparator => ({ value: comparator, label: ComparatorLabel[comparator] }));
};

export default getComparator;
